import FolderSpecialOutlinedIcon from '@mui/icons-material/FolderSpecialOutlined';
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

interface OptimizationProjectCardProps {
  projectName: string;
  conditionAreaName: string;
  healthSystemName: string;
  isLoading: boolean;
}

export const OptimizationProjectCard = ({
  projectName,
  conditionAreaName,
  healthSystemName,
  isLoading,
}: OptimizationProjectCardProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
        p: theme.spacing(4),
        borderRadius: 1,
        backgroundColor: theme.palette.grey[100],
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.primary.dark,
          color: theme.palette.white.main,
          flexShrink: 0,
        }}
      >
        <FolderSpecialOutlinedIcon />
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {formatMessage({ id: 'adminProjects.generateAccuracy.optimizationProject.label' })}
        </Typography>
        {isLoading ? (
          <>
            <Skeleton variant="text" width={240} height={28} />
            <Skeleton variant="text" width={180} height={20} />
          </>
        ) : (
          <>
            <Typography variant="h6">{projectName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {[conditionAreaName, healthSystemName].filter(Boolean).join(' · ')}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};
